import { Box, Image, VStack } from '@chakra-ui/react';
import { IBanner } from '@partiu/api/types';
import { Fragment } from 'react';
import { Carousel as ResponsiveCarousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader

export function BannerCarousel({ banners }: { banners: IBanner[] }) {
  if (!banners || banners.length === 0) return null;

  return (
    <VStack width={'100%'} padding={0} margin={'auto'} minHeight={'50px'} marginBottom={'-40px'}>
      <ResponsiveCarousel>
        {banners.map((b) => (
          <Fragment key={b.name}>
            <Box display={{ base: 'initial', lg: 'none' }}>
              <Image src={b.imageMobile} />
            </Box>
            <Box display={{ base: 'none', lg: 'initial' }}>
              <Image src={b.image} />
            </Box>
          </Fragment>
        ))}
      </ResponsiveCarousel>
    </VStack>
  );
}
